<label readonly><span class="headerstatusIndicator"
    [ngStyle]="{'background-color': statusColor}"></span>{{statusText}}</label>